import { useActiveOwners } from 'src/features/common/collectible/hooks/use-nft-owners';
import { useProfile } from '../../profile/hooks/profile.hooks';
import { useCollectible } from './collectible.hooks';

export const useIsCanEditCollectible = () => {
    const profile = useProfile();
    const nft = useCollectible();
    const activeOwners = useActiveOwners();

    // @ts-ignore
    return (activeOwners.totalCount === 1 && nft?.authorId === nft?.ownerId && profile?.user?.id === nft?.authorId);
};
